export default function LoginModal({ toggleClose }) {
    return (
        <div>
            <h1>Login Modal</h1>
            <button onClick={() => toggleClose(false)}>Close</button>
        </div>
    )
}